import AppService from '@/services/AppService.js'
const namespaced = true
const state = {
    code: '',
    updated_id: '',
    lists: {},
    total_count: '',
    count: 1,
    list: {},
    filter_list: {},
    filter_name: '',
    Updatelist: {},
    search_criteria: '',
    message: '',
    error: '',
    details: '',
    tag_list: [],
    is_no_records: '',
    log_details: '',
    export: {},
    status_code: '',
    status_message: '',
    status_type: '',
    payment_index_history:'',
    index_status:''

}
const mutations = {
    SET_DATAS(state, lists) {
        state.error = ''
        state.lists = lists.payment_list
        state.total_count = lists.total_count
        state.count = lists.show
        state.search_criteria = lists.search
        state.is_no_records = lists.is_no_records
        state.filter_list = lists.filter_list
        state.filter_name = lists.filter_name
    },
    LIST_DATA(state, list) {
        state.list = list
        state.error = ''
    },
    LIST_UPDATE_DATA(state, list) {
        state.Updatelist = list
        state.error = ''
    },
    EMAIL_RESULT(state, email_result) {
        state.email = email_result
        state.error = ''
    },
    LIST_ID(state, updated_id) {
        state.updated_id = updated_id.payment_hdr
        state.error = ''
    },
    STATUS_CODE(state, code) {
        state.code = code
        state.error = ''
    },
    ERROR_STATUS(state, code) {
        state.error = code
    },
    LIST_LOG(state, data) {
        state.log_details = data
    },
    LIST_DETAILS(state, data) {
        state.details = data
    },
    EXPORT_DATAS(state, lists) {
        state.export = lists
    },
    CANCEL_STATUS(state, data) {
        state.message = data
        state.error = ''
    },
    SET_CODE(state, data) {
        state.status_code = data.code;
        state.status_message = data.status;
        state.status_type = data.type;
    },



}
const actions = {
    fetchPaymentmethod({
        commit,
        rootState
    }, data) {
        return AppService.payment.postPaymentdetails(data, rootState.session.token)
            .then(response => {
                rootState.general.filterdetails = response.data
                commit('LIST_DETAILS', response.data) // getting all the list in the api call
            })
            .catch(error => {
                if (!error.response) {
                    commit('ERROR_STATUS', 500) // getting all the list in the api call
                }
            })
    },

    fetchLists({
        commit,
        rootState
    }, {
        page,
        show,
        search,
        status,
        sort,
        label,
        from_date,
        to_date,
        custom
    }) {

        return AppService.payment.getPayments(page, show, search, status, sort, label, from_date, to_date, custom, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.data.code != 404) {
                    commit("SET_CODE", response.data);
                    commit("SET_DATAS", response.data.data); // getting all the list in the api call
                  } else {
                    commit("SET_CODE", response.data);
                  }
                  return response

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchexportLists({
        commit,
        rootState
    }, {
        page,
        show,
        search,
        status,
        sort,
        label,
        from_date,
        to_date,
        custom
    }) {


        return AppService.payment.getPaymentsExport(page, show, search, status, sort, label, from_date, to_date, custom, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data)
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchList({
        commit,
        rootState
    }, id) {

        return AppService.payment.getPaymentReceive(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data)
                    commit('LIST_DATA', response.data) // getting all the list in the api call

                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchviewList({
        commit,
        rootState
    }, id) {

        return AppService.payment.getPaymentReceiveView(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data)
                    commit('LIST_DATA', response.data) // getting all the list in the api call

                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    createList({
        commit,
        rootState
    }, list) {

        return AppService.payment.postPaymentReceive(list, rootState.session.token)
            .then(response => {

                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.data.code== 201) {
                    commit("SET_CODE", response.data)
                    commit('CANCEL_STATUS', response.data.data)
                } else {
                    commit("SET_CODE", response.data)
                    commit('LIST_ID', response.data.data)
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    updateList({
        commit,
        rootState
    }, {
        id,
        field
    }) {

        return AppService.payment.postPaymentReceiveUpdate(field, id, rootState.session.token)
            .then(response => {
                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.data.code== 201) {
                    commit("SET_CODE", response.data)
                    commit('CANCEL_STATUS', response.data.data)
                } else {
                    commit("SET_CODE", response.data)
                    commit('LIST_ID', response.data.data)
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    updateRefund({
        commit,
        rootState
    }, {
        id,
        field
    }) {

        return AppService.payment.postPaymentRefundUpdate(id, field, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                      commit("SET_CODE", response.data)
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                    return response
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    deleteRefund({
        commit,
        rootState
    }, id) {

        return AppService.payment.postPaymentRefundDelete(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                    return response
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    deletepayment({
        commit,
        rootState
    }, data) {

        return AppService.payment.getPaymentReceiveDelete(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
                return error
            })
    },
    filtercreateList({
        commit,
        rootState
    }, data) {

        return AppService.payment.postFiltercreatePayment(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data) // getting all the list in the api call
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    filterdelete({
        commit,
        rootState
    }, data) {

        return AppService.payment.postFilterdeletePayment(data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    filterupdateList({
        commit,
        rootState
    }, {
        id,
        data
    }) {

        return AppService.payment.postFilterudpatePayment(data, id, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                }
                else if(response.status == 201) {
                    commit("SET_CODE", response.data);
                }
                 else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data) // getting all the list in the api call
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    bulkdelete({
        commit,
        rootState
    }, id) {

        return AppService.payment.postPaymentBulkDelete(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data)
                    commit('LIST_LOG', response.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },

}
export default {
    namespaced,
    state,
    mutations,
    actions
}